import { InfoBoxService } from 'src/app/services/info-box.service';
import { PostData } from './../../home/models/post-data.model';
import { Title } from '@angular/platform-browser';
import { PostsService } from './../../../services/posts.service';
import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';
import { SettingsService } from '../../settings/settings.service';
import { ActivatedRoute } from '@angular/router';
import { Subject, lastValueFrom } from 'rxjs';
import { ScrollService } from 'src/app/services/scroll.service';
import { AuthService } from 'src/app/services';
import { UserRoleEnum } from 'src/app/enums/userRoleEnum';
import { HelpService } from '../../help/help.service';
import { CryptoRandomFloat } from 'src/app/common/crypto-random-float';

@Component({
    selector: 'app-feed',
    templateUrl: './feed.component.html',
    styleUrls: ['./feed.component.scss'],
    standalone: false
})
export class FeedComponent implements OnInit {
 
	// === Client side === 
	public getRandomHeight(min: number, max: number): number {
		
		
		return Math.floor(CryptoRandomFloat.getCryptoRandomFloat() * (max - min + 1)) + min;
	}

	public reload: boolean = true;

	private _reload() {
		this.reload = false;

		setTimeout(() => this.reload = true);
	}
	public postTitle = "";
	public feedItems: { postData: PostData, expanded: boolean }[] = [];

	public focusedFeedItem: { postData: PostData, expanded: boolean, visible: boolean, editMode: boolean };

	private static readonly INITIAL_FEED_ITEMS_QUANTITY: number = 6;

	public isAdmin: boolean;

	// <General page fields>
	private readonly _componentTitle = "Feed";
	private readonly _focusedFeedItemIdQueryParamName = "id";

	// </General page fields>

	constructor(
		private titleService: Title,
		private notificationService: NotificationService,
		private postsService: PostsService,
		private settingsService: SettingsService,
		private infoBoxService: InfoBoxService,
		private route: ActivatedRoute,
		private _scrollService: ScrollService,
		private _authService: AuthService,
		private helpService: HelpService
	) { }

	ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		this._scrollService.scrolledDownObservable.subscribe(
			{
				next: () => {
					this.addFeedItems(2);
				}
			}
		);

		this.isAdmin = this._authService.currentRole === UserRoleEnum.Admin;

		this.subOnPostDelete$.subscribe(
			{
				next: (deletedPostId) => {
			
					this.onDeletePostConfrimButtonClicked();
				}
			}
		);

		this.subOnPostCancel$.subscribe(
			{
				next: (postId) => {
	
				}
			}
		);

		this.initializeColorValues();

		this.addFeedItems(FeedComponent.INITIAL_FEED_ITEMS_QUANTITY).then(
			(response) => {
				this.route.queryParamMap.subscribe(
					(queryParams) => {
						let focusedFeedItemId = Number.parseInt(queryParams.get(this._focusedFeedItemIdQueryParamName));

						if (focusedFeedItemId && this.feedItems.length > 0) {
							this.focusFeedItem(this.feedItems.find((feedItem) => feedItem.postData.id === focusedFeedItemId).postData);

						
						}
					}
				);
			}
		);
	}

	public refreshFeed() {
		this.feedItems = [];

		this.addFeedItems(FeedComponent.INITIAL_FEED_ITEMS_QUANTITY);
	}

	// Adds lacking objects to feed.
	public async addFeedItems(quantity: number): Promise<void> {
		let lastItemId = this.feedItems.length > 0 ? this.feedItems[this.feedItems.length - 1].postData.id : -1;

		const observable$ = this.postsService.getLatestPosts(
			lastItemId,
			quantity,
			{
				showLoadingIndicator: true,
			}
		);

		const response = await lastValueFrom(observable$);
		

		for (let a = 0; a < response.length; a++) {
			const postData = response[a];

			this.feedItems.push({ postData: postData, expanded: false });
		}
	}

	public focusFeedItem(postData: PostData) {
		this.focusedFeedItem = { postData: postData, expanded: true, visible: true, editMode: false };
	}

	public newPostPopupActive: boolean;

	public onPostPopupSave(formValues: any) {
	

		let postData = formValues as PostData;

		if (formValues.icon.icon != null && formValues.icon.icon != undefined) {
			postData.icon = formValues.icon.icon;
		}

		this.postsService.upsertPost(postData).subscribe(
			{
				next: (response) => {
			

					this.infoBoxService.show(
						{
							message: response.message,
						}
					);

					if (response.success) {
						this.newPostPopupActive = false;

						this.refreshFeed();
					}
				}
			}
		);
	}

	public deletePostId: number = 0;
	public deletePostConfirmationPopUpVisible: boolean;

	public onDeletePostConfrimButtonClicked() {
		

		this.postsService.deletePost(this.deletePostId).subscribe(
			{
				next: (response) => {
				

					this.infoBoxService.show({ message: response.message });

					if (response.success) {
						this.feedItems = this.feedItems.filter(item => item.postData.id !== this.deletePostId);
					}
				}
			}
		);
	}

	public onDeletePostCancelButtonClicked() {
		

		this.deletePostId = 0;
	}

	public subOnPostDelete$ = new Subject();
	public subOnPostCancel$ = new Subject();
	public buttonsData = [
		{
			text: "Confirm",
			onClick: this.subOnPostDelete$
		},
		{
			text: "Cancel",
			onClick: this.subOnPostCancel$
		}
	];


	public onPostDelete(id: number, evt: any) {
	
		this.deletePostId = id;

		if (evt != null && evt["previewTitle"] != null) {
			this.postTitle = `Do you want to delete post "${evt["previewTitle"]}"?`;
		}

		this.deletePostConfirmationPopUpVisible = true;
	}

	public onPostClick(postData: PostData) {
	
	}

	public postCardBackgroundColor: string;
	public postCardInfoTitleTextColor: string;
	public postCardMainTextColor: string;
	public postCardPriorityIndicatorTextColor: string;
	public postCardPriorityBackgroundColor: string;

	//TODO: Optimize this to 1 request call.
	public initializeColorValues() {
		this.settingsService.getCoreSetting(null, "PostCardBackgroundColor").then(
			(response) => {
				

				this.postCardBackgroundColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "PostCardInfoTitleTextColor").then(
			(response) => {
				

				this.postCardInfoTitleTextColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "PostCardMainTextColor").then(
			(response) => {
				

				this.postCardMainTextColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "PostCardPriorityIndicatorTextColor").then(
			(response) => {
		

				this.postCardPriorityIndicatorTextColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "PostCardPriorityBackgroundColor").then(
			(response) => {
				

				this.postCardPriorityBackgroundColor = response.value;
			}
		);
	}

	onHelpButtonClicked(event){
		this.helpService.openHelpPageById();
	}
	public onPostFocusPopupHeightChange(event: any) {
	
	}
	
}
